import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { leasingServiceUrl } from '~/utils/env';

export abstract class LeasingBaseRepository extends BaseRestRepository {
  protected baseUrl(path: string): string {
    const base = leasingServiceUrl();
    const suffix = path.startsWith('/') ? path : `/${path}`;
    return `${base}/company-portal${suffix}`;
  }
}
